import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { API } from "@/config/api";

// First-paint telemetry timestamps
const _startupTs = Date.now();
window.__duolyst_startup_ts = _startupTs;

// Remove startup shell once React takes over
const removeStartupShell = () => {
  const shell = document.getElementById('startup-shell');
  const reactReadyTs = Date.now();
  if (shell) {
    shell.style.transition = 'opacity 0.2s ease';
    shell.style.opacity = '0';
    setTimeout(() => shell.remove(), 250);
  }
  // Signal native wrapper that app is ready
  if (window.isNativeApp && window.ReactNativeWebView) {
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'APP_READY' }));
    } catch (e) {}
  }
  // Log first-paint telemetry
  const firstPaintMs = reactReadyTs - _startupTs;
  console.log(`[DuoLyst] first_dom_paint_ms: ${firstPaintMs}`);
  // Fire telemetry beacon (non-blocking)
  try {
    const token = localStorage.getItem('token');
    if (token) {
      fetch(`${API}/subscription/telemetry`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({
          event: 'first_dom_paint',
          metadata: {
            first_dom_paint_ms: firstPaintMs,
            is_native: !!window.isNativeApp,
            platform: window.nativePlatform || 'web',
          }
        }),
      }).catch(() => {});
    }
  } catch (e) {}
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App onReady={removeStartupShell} />
  </React.StrictMode>,
);
